/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Credit_Packs_IntroInputs */

const en_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In addition to subscriptions, Alchema offers one-time credit packs:`)
};

const de_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neben dem Abonnement bietet Alchema einmalige Credit-Pakete an:`)
};

const fr_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En plus des abonnements, Alchema propose des packs de credits uniques :`)
};

const es_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ademas de las suscripciones, Alchema ofrece paquetes de creditos unicos:`)
};

const it_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre agli abbonamenti, Alchema offre pacchetti di crediti una tantum:`)
};

const nl_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naast abonnementen biedt Alchema eenmalige creditpakketten:`)
};

const pl_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprocz subskrypcji, Alchema oferuje jednorazowe paczki kredytow:`)
};

const fi_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilausten lisäksi Alchema tarjoaa kertaostettavia krediittipaketteja:`)
};

const da_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ud over abonnementer tilbyder Alchema engangskreditpakker:`)
};

const sv_agb_credit_packs_intro = /** @type {(inputs: Agb_Credit_Packs_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utover prenumerationer erbjuder Alchema engangskreditpaket:`)
};

/**
* | output |
* | --- |
* | "In addition to subscriptions, Alchema offers one-time credit packs:" |
*
* @param {Agb_Credit_Packs_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_credit_packs_intro = /** @type {((inputs?: Agb_Credit_Packs_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Credit_Packs_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_credit_packs_intro(inputs)
	if (locale === "fr") return fr_agb_credit_packs_intro(inputs)
	if (locale === "es") return es_agb_credit_packs_intro(inputs)
	if (locale === "it") return it_agb_credit_packs_intro(inputs)
	if (locale === "nl") return nl_agb_credit_packs_intro(inputs)
	if (locale === "pl") return pl_agb_credit_packs_intro(inputs)
	if (locale === "fi") return fi_agb_credit_packs_intro(inputs)
	if (locale === "da") return da_agb_credit_packs_intro(inputs)
	if (locale === "sv") return sv_agb_credit_packs_intro(inputs)
	return en_agb_credit_packs_intro(inputs)
});